import * as React from "react";
import {IReadSubOrganizationResponse} from "../../../core/api/organization/response/ReadSubOrganizationResponse";
import {SubOrganizationApiService} from "../../../core/api/organization/SubOrganizationApiService";
import {SubOrganizationItem} from "../../../component/village-organization/sub-organization/SubOrganizationItem";

interface IProps {
    organizationSlug: string;
    organizationId: string;
}

interface IState {
    data: IReadSubOrganizationResponse[] | undefined;
}

export class VillageSubOrganization extends React.Component<IProps, IState> {

    private readonly apiService = new SubOrganizationApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: undefined
        }
    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <section>
                <div className="row">
                    <div className="col-sm-12">

                        {this.state.data === undefined ? <p>Loading...</p> : (
                            <div>
                                {this.state.data.length < 1 ? <p>Data tidak ditemukan.</p> : this.state.data.map((item, index) =>
                                    <SubOrganizationItem key={index} data={item} organizationSlug={this.props.organizationSlug}  />
                                )}
                            </div>
                        )}

                        {/*<div className="pagination">
                                    <a className="active" href="blog-classic-sidebar-right.html">1</a>
                                    <a href="blog-classic-sidebar-right.html">2</a>
                                    <a href="blog-classic-sidebar-right.html">3</a>
                                    <a className="no-active">...</a>
                                    <a href="blog-classic-sidebar-right.html">9</a>
                                </div>*/}

                    </div>
                </div>
            </section>
        );
    }

    private fetchData = () => {
        this.apiService.getByOrganization(this.props.organizationId)
            .then((response: any) => {
                this.setState({
                    data: response.result
                })
            }).catch((error) => {
            this.setState({
                data: []
            })
        })
    }

}


// WEBPACK FOOTER //
// ./src/screen/village-organization/sub-organization/VillageSubOrganization.tsx